module.exports = __webpack_public_path__ + "static/media/paper2.01df95e8.png";